import React, { useState, useEffect, useRef } from "react";
import { setCurrentAppId, setTemplateId } from "../../store/userAuthSlice";
import SideNav from "./SideNav";
import {
    AppLayout,
    Button,
    ColumnLayout,
    Input,
    Icon,
    Textarea,
    Container,
    Header,
    Box,
    SpaceBetween,
    Link,
    ContentLayout,
    Table,
    Modal,
    Spinner,
    HelpPanel,
    Flashbar,
    Alert,
    Checkbox,
    RadioGroup,
    Popover,
} from "@amzn/awsui-components-react";

import { CodeView } from '@amzn/awsui-code-view';


import "../../index.scss";
import "./styles.scss"
import { useSelector, useDispatch } from "react-redux";
import { canAddEditDeleteApplication } from "../Templates/Utils/Permissions";
import { useHistory, useParams, useLocation } from "react-router-dom";

import {v4 as uuidv4} from 'uuid'

import CustomInput from "../Templates/components/CustomInput";
import CustomSelect from "../Templates/components/CustomSelect";
import CustomCheckbox from "../Templates/components/CustomCheckbox";
import CustomMultiHybridInputAndSelect from "../Templates/components/CustomMultiHybridInputAndSelect";
import { getEditableFields } from "../Templates/Utils/FormMetadata";
import { getAppPromise, createAuditLog } from "src/Ateam-BI/Templates/Utils/AppActivityUtils"
import { useSuggestedLogins } from "src/hooks/useSuggestedLogins";
import { TEMPLATE_APP, APPS_WITH_APP_LEVEL_PERMISSIONS_IN_TEMPLATE } from "../Templates/Constants";
import { FLEXICO_STEP_FUNCTION_CONFIG } from 'src/constants/AppConstants';
import Feedback from "src/generic-components/UserFeedback/Feedback";
import { configureFlexicoS3, configureGenericAppSync, configureGenericS3 } from "src/context/AuthContextUtility";
import { createFlexicoTemplate, deleteFlexicoTemplate, getFlexicoTemplate, updateFlexicoTemplate } from "src/utilities/FlexicoAPIs";
import { APPROVER_TYPES, FLEXICO_NEGATIVE_STATUS, FLEXICO_POSITIVE_STATUS, FLEXICO_TEMPLATE_STATUS, FLEXICO_TEMPLATE_KEYS, UPLOADER_TYPES } from "./Constants";
import { RippleIDTypes } from "src/generic-components/Ripple/Constants";
import RippleComponentManager from "src/generic-components/Ripple/RippleComponentManager";
import TANCManager from "../TANC/TANCManager";
import { disableTANCSync, enableTANCSync, tancAssociationStatus } from "src/utilities/AppSyncPlusAPIs";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getCustomAttribute as getCustomAttributeUtil, updateCustomAttribute as updateCustomAttributeUtil } from "../utils/customAttributeUtils";
import ParameterDetails from "./ParameterDetails/ParameterDetails";

export default (props) => {
    const dispatch = useDispatch();
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const templateId = useSelector((globalState) => globalState.auth.templateId)
    const history = useHistory();
    const [NavOpen, setNavOpen] = useState(true);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const userId = useSelector((globalState) => globalState.auth.userId);
    let { id: paramId } = useParams();
    let { fid: paramFid } = useParams();
    
    const id = props.id || paramId;
    const fid = props.fid || paramFid;
    const [isNewFlexicoTemplate, setIsNewFlexicoTemplate] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [alertErrorMessage, setAlertErrorMessage] = useState(null)
    const [accessPerms, setAccessPerms] = useState(props.accessPerms);
    const [canDelete, setCanDelete] = useState(false)
    const [canEdit, setCanEdit] = useState(false)
    const [canAdd, setCanAdd] = useState(false)
    const [enableEditAction, setEnableEditAction] = useState(false)
    const [flexicoTemplateData, setFlexicoTemplateData] = useState({})
    const flexicoTemplateDataRef = useRef({})
    const [flexicoTemplateDataEdited, setFlexicoTemplateDataEdited] = useState({})
    const [fieldMetadata, setFieldMetadata] = useState({});
    const [sampleFile, setSampleFile] = useState([]);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const [updateNotificationModal, setUpdateNotificationModal] = useState(false);
    const [updateNotificationModalError, setUpdateNotificationModalError] = useState(false);
    const [deleteAppName, setDeleteAppName] = useState('');
    const [flashBarComments, setFlashBarComments] = useState();
    const [isApprovalDisabled, setIsApprovalDisabled] = useState(false);
    const [backUrl, setBackUrl] = useState(null)
    const [updateComments, setUpdateComments] = useState("")
    const [modalError, setModalError] = useState("")
    const [toolsOpen, setToolsOpen] = useState(false);
    const [mandatoryParameters, setMandatoryParameters] = useState([]);
    const [deleteDataOnUpdate, setDeleteDataOnUpdate] = useState(false)
    const [dataGenerationPlatform, setDataGenerationPlatform] = useState('')
    const [dataSharePlatform, setDataSharePlatform] = useState('')
    const [dataGenerationPlatformClass, setDataGenerationPlatformClass] = useState('')
    const [dataSharePlatformClass, setDataSharePlatformClass] = useState('')
    const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
    const [shouldSubmitRipple, setShouldSubmitRipple] = useState(false)
    const [reloadNotifier, setReloadNotifier] = useState(false)
    const [tancEnabled, setTancEnabled] = useState(false)
    const [tancEnabledExistingStatus, setTancEnabledExistingStatus] = useState(false)
    const [showTancPermissionModal, setShowTancPermissionModal] = useState(false)
    const [tancInfo, setTancInfo] = useState(null)
    const [refreshModal, showRefreshModal] = useState(false)
    const [flexicoTempId, setFlexicoTempId] = useState(fid? `TEMP_FLEXICO_${fid}` : `TEMP_FLEXICO_${uuidv4()}`)
    const [isDynamicInputParametersAvailable, setIsDynamicInputParametersAvailable] = useState(false)
    const PREFERENCE_VARIABLE_INFO = <Box>Supported variables :  Any input parameters and {'{'}template_name{'}'}, {'{'}file_id{'}'}, {'{'}current_quarter{'}'}, {'{'}previous_quarter{'}'}, {'{'}month{'}'}, {'{'}previous_month{'}'}, {'{'}year{'}'}, {'{'}current_year{'}'}, {'{'}previous_year{'}'}, {'{'}previous_month_year{'}'}, {'{'}current_month_year{'}'}, {'{'}label{'}'}</Box>


    const tancManagerRef = useRef();
    const ln = useLocation()
    useVisibleTimeTracker([{
        metricName : 'actionPerformedBy',
        metricValue : userId,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    },
    {
        metricName : 'pagePath',
        metricValue : `${ln.pathname}`,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FLEXICO);

    useEffect(() => {
        configureFlexicoS3()
        setInitView()
        setBackUrl(getParam('back'))
        return () => {
            // this now gets called when the component unmounts
            configureGenericAppSync()
            configureGenericS3()
        };
    }, []);

    useEffect(() => {
        if (flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.critical_data) && flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.sox_approved)) {

            if (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.critical_data] && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved]) {
                setDataGenerationPlatform("Red")
                setDataSharePlatform("None")
                setDataGenerationPlatformClass("red_badge")
                setDataSharePlatformClass("grey_badge")
            } else if (!flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.critical_data] && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved]) {
                setDataGenerationPlatform("Red")
                setDataSharePlatform("Orange")
                setDataGenerationPlatformClass("red_badge")
                setDataSharePlatformClass("orange_badge")
            } else if (!flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.critical_data] && !flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved]) {
                setDataGenerationPlatform("Orange")
                setDataSharePlatform("Red")
                setDataGenerationPlatformClass("orange_badge")
                setDataSharePlatformClass("red_badge")
            } else if (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.critical_data] && !flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved]) {
                setDataGenerationPlatform("Red")
                setDataSharePlatform("None")
                setDataGenerationPlatformClass("red_badge")
                setDataSharePlatformClass("grey_badge")
            }

        }

        if (flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type)) {
            if ((flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Parameters only'
            || flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'None')
            && (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved] || flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approval_required]) ){
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approvers] = []
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved] = false
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approval_required] = false
                setIsApprovalDisabled(false)
                setFlexicoTemplateDataEdited({...flexicoTemplateDataEdited})
            }
        }
    }, [flexicoTemplateDataEdited])

    useEffect(() => {
        setFlexicoTemplateDataEdited(flexicoTemplateData)
        if (flexicoTemplateData.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.status)
            && flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.status]
            && flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.status].toLowerCase().includes("failed")) {
            setFlashBarComments([{
                type: "error",
                dismissible: true,
                dismissLabel: "Dismiss message",
                onDismiss: () => setFlashBarComments([]),
                content: (
                    <>
                        {flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.status]}
                    </>
                ),
                id: "comments"
            }])
        }
        
    }, [flexicoTemplateData])

    useEffect(() => {
        if (sampleFile.length > 0) {
            suggestSchema()
        }
    }, [sampleFile])

    useEffect(() => {
        checkIfFormIsSubmittable()
    }, [flexicoTemplateDataEdited, canEdit])

    useEffect(() => {
    if (tancInfo?.tanc_id != null && tancInfo?.association_id == fid
      && tancInfo?.association_id_type == 'FLEXICO') {
      setTancEnabledExistingStatus(tancInfo?.status)
      setTancEnabled(tancInfo?.status)
    } else {
      setTancEnabledExistingStatus(false)
      setTancEnabled(false)
    }
  }, [tancInfo])


    const dismissDeleteDialog = () => {
        setDeleteAppName('')
        setDeleteConfirmationModal(false)
    }

    const dismissUpdateNotifyDialog = () => {
        setUpdateNotificationModal(false)
    }

    const getParam = (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
    }

    const getGroup = () => {
        return getParam('group')
    }

    const setInitView = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        let group_id = getGroup()
        if (group_id) {
            flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.group_id] = group_id
        }
        let next_step = getParam('next_step')
        if (next_step) {
            flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.next_step] = next_step
        }
        flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.app_id] = id

        let params = []
        params.push({ 'label': 'contico_job', 'field_type': 'fixed_inputs', 'limit': 1 })
        setMandatoryParameters(params)

        loadEditableFields()
        if (fid) {
            dispatch(setCurrentAppId(id));
            await loadData();
            setIsEditMode(false)
            setIsNewFlexicoTemplate(false)
        } else {
            setIsNewFlexicoTemplate(true)
            setShowLoadingIcon(false);
            (!isEditMode) ? setIsEditMode(true) : ''
        }
        let appTemplateID = templateId
        if (!templateId) {
            // fetch template from app id
            let result = await getAppPromise(id)
            setTemplateId(result.data.getAppsV2[0][TEMPLATE_APP.TEMPLATE_ID])
            appTemplateID = result.data.getAppsV2[0][TEMPLATE_APP.TEMPLATE_ID]
        }
        let accessPerms;
        if (id && APPS_WITH_APP_LEVEL_PERMISSIONS_IN_TEMPLATE[currentStage?.toUpperCase()].includes(id)) {
            accessPerms = await canAddEditDeleteApplication(userId, id, currentStage)
        }
        else {
            accessPerms = await canAddEditDeleteApplication(userId, appTemplateID, currentStage)
        }
        setCanDelete(accessPerms?.delete)
        setCanEdit(accessPerms?.edit)
        setCanAdd(accessPerms?.add)

        // !fid means isNewTemplate=true. Sometimes the useeffect take time, so relying on fid. fid is a path param
        if (!fid && !accessPerms?.add) {
            setAlertErrorMessage(
                {
                    "header": "Access denied",
                    "message": "No access to add a new process"
                }
            )
        } else {
            setAlertErrorMessage(null)
        }
    } finally {
        if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FLEXICO)
        }
    }
    }

    const loadData = async () => {
        // setProcessData()
        if (!fid || fid === 'new') {
            setShowLoadingIcon(false);
            return;
        }
        await Promise.all([
        new Promise((resolve, reject) => {
            getFlexicoTemplate(fid, function onSuccess(response) {
            setFlexicoTemplateData(response.data.getFlexicoTemplateRDS)
            flexicoTemplateDataRef.current = response.data.getFlexicoTemplateRDS
            let parameters = response.data.getFlexicoTemplateRDS?.parameters || []
            for(let parameter of parameters){
                if(parameter?.field_type?.startsWith("dynamic_")){
                    setIsDynamicInputParametersAvailable(true)
                    break
                }
            }
            setShowLoadingIcon(false);
            resolve()
        }, function onFailure(response) {
            setShowLoadingIcon(false);
            reject()
        })
        }),
        new Promise((resolve, reject) => {
            tancAssociationStatus(fid, 'FLEXICO', function onSuccess(response){
              setTancInfo(response?.data?.tancAssociationStatus)
              if(tancManagerRef?.current?.props?.tancId){
                tancManagerRef.current.props.tancId = response.data.tancAssociationStatus.tanc_id
              }
              resolve();
            }, function onFailure(response){
              reject();
            })
            })])
           
    }

    const loadEditableFields = async () => {
        let res = await getEditableFields()
        res[FLEXICO_TEMPLATE_KEYS.approvers] = { values: [{ label: "USER", value: APPROVER_TYPES.APPROVER }, { label: "LDAP", value: APPROVER_TYPES.APPROVER_LDAP }] }
        res[FLEXICO_TEMPLATE_KEYS.uploaders] = { values: [{ label: "USER", value: UPLOADER_TYPES.UPLOADER }, { label: "LDAP", value: UPLOADER_TYPES.UPLOADER_LDAP }] }
        res[FLEXICO_TEMPLATE_KEYS.file_types] = res[`flexico_${FLEXICO_TEMPLATE_KEYS.file_types}`]
        res[FLEXICO_TEMPLATE_KEYS.trigger_type] = res[`flexico_${FLEXICO_TEMPLATE_KEYS.trigger_type}`]
        setFieldMetadata(res)
    }

    const getSelectFieldValues = (fieldName, subKey = null) => {
        if (fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['values']) {
            return fieldMetadata[fieldName]['values']
        } else if (subKey && fieldMetadata && fieldMetadata[fieldName][subKey] && fieldMetadata[fieldName][subKey]['values']) {
            return fieldMetadata[fieldName][subKey]['values']
        } else {
            return []
        }
    }

    const getCustomAttribute = (attribute_type, sub_type) => {
        return getCustomAttributeUtil(
            flexicoTemplateDataEdited, 
            attribute_type, 
            sub_type, 
            FLEXICO_TEMPLATE_KEYS.custom_attributes,
            FLEXICO_TEMPLATE_KEYS.CUSTOM_ATTRIBUTES_KEYS
        );
    }

    const updateValueCustomAttributes = (fieldName, value, subKey = null) => {
        updateCustomAttributeUtil(
            flexicoTemplateDataEdited,
            fieldName,
            value,
            'FLEXICO',
            FLEXICO_TEMPLATE_KEYS.custom_attributes,
            FLEXICO_TEMPLATE_KEYS.CUSTOM_ATTRIBUTES_KEYS
        );
        setFlexicoTemplateDataEdited(JSON.parse(JSON.stringify(flexicoTemplateDataEdited)));
    }

    const getValueCustomAttributes = (fieldName, subKey = null) => {
        let val = getCustomAttribute(fieldName, 'FLEXICO')[0]
        return val
    }

    const updateValue = (fieldName, value, subKey = null) => {
        if (subKey) {
            if (!flexicoTemplateDataEdited.hasOwnProperty(fieldName)) {
                flexicoTemplateDataEdited[fieldName] = {}
            }
            flexicoTemplateDataEdited[fieldName][subKey] = value
        } else {
            flexicoTemplateDataEdited[fieldName] = value
        }
        if (fieldName == FLEXICO_TEMPLATE_KEYS.sox_approved) {
            if (value && (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file with parameters' || flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file only')) {
                // approval required MUST be true
                setIsApprovalDisabled(true)
                updateValue(FLEXICO_TEMPLATE_KEYS.approval_required, true)
            } else {
                setIsApprovalDisabled(false)
            }
        }


        setFlexicoTemplateDataEdited(JSON.parse(JSON.stringify(flexicoTemplateDataEdited)))
    }


    const getValue = (fieldName, subKey = null) => {
        if (subKey) {
            if (flexicoTemplateDataEdited.hasOwnProperty(fieldName)) {
                return flexicoTemplateDataEdited[fieldName][subKey]
            } else {
                return null
            }
        } else {
            return flexicoTemplateDataEdited[fieldName]
        }
    }

    const getMultiInputFieldValues = (fieldName) => {
        if (flexicoTemplateDataEdited && flexicoTemplateDataEdited[fieldName]) {
            return flexicoTemplateDataEdited[fieldName]
        } else {
            return []
        }
    }

    const getMultiSelectedOptions = (fieldName) => {
        let arr = flexicoTemplateDataEdited[fieldName]
        let selectedOptions = []
        if (arr) {
            arr.forEach((item) => {
                selectedOptions.push({ label: item, value: item })
            })
        }
        return selectedOptions
    }

    const postProcessTeamEmails = (value) => {
        return value.replaceAll("@amazon.com", "")
    }

    const approversValidation = (elements) => {
        let emptyValues = true
        elements?.forEach((element) => {
            if (!element.type || !element.alias) {
                emptyValues = false
            }
        })
        return emptyValues
    }

    const mandatoryFieldListener = (key, enableUpdate) => {
        // mandatoryFieldsMissing[key] = enableUpdate
    }

    const checkIfNull = (data, field, missingFields) => {
        if (data && (!data.hasOwnProperty(field) || !data[field])) {
            missingFields.push(field)
        } else if (Array.isArray(data[field]) && data[field].length <= 0) {
            missingFields.push(field)
        }
    }

    const getMissingFields = (data, fields) => {
        let missingFields = []
        fields.forEach((field) => {
            if (typeof field == 'string') {
                checkIfNull(data, field, missingFields)
            } else {
                if (field?.mainKey) {
                    field.subKeys.forEach(subKey => {
                        data[field.mainKey]?.forEach((item) => {
                            checkIfNull(item, subKey, missingFields)
                        })
                    })
                }
            }
        })
        return missingFields
    }

    const checkIfParameterAreAvailable = (data, fields) => {
        let dataFields = []
        for (let i = 0; i < data?.length; i++) {
            if (data[i]['field_values']?.length > 0) {
                dataFields.push(data[i]['label'])
            }
        }
        let missing = []
        for (let i = 0; i < fields?.length; i++) {
            if (!dataFields?.includes(fields[i])) {
                missing.push(fields[i])
            }
        }
        return missing
    }
    const checkIfParameterAreAvailableByType = (data, types) => {
        let missing = []
        for (let i = 0; i < data?.length; i++) {
            if (types.includes(data[i]['field_type']) && data[i]['field_values']?.length <= 0) {
                missing.push(data[i]['label'])
            }
        }
        return missing
    }

    const checkIfFormIsSubmittable = () => {
        let missingFields = getMissingFields(flexicoTemplateDataEdited, [FLEXICO_TEMPLATE_KEYS.template_name])
        if (missingFields.length <= 0) {
            let missingFields2 = getMissingFields(flexicoTemplateDataEdited, [])
            missingFields = [...missingFields, ...missingFields2]
        }
        let missingParameters = checkIfParameterAreAvailable(flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.parameters], ['contico_job'])
        missingFields = [...missingFields, ...missingParameters]
        let missingParametersByType = checkIfParameterAreAvailableByType(flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.parameters], ['fixed_inputs'])
        missingFields = [...missingFields, ...missingParametersByType]
        if (missingFields.length <= 0
            && flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.approval_required)
            && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approval_required]) {
            if (!missingFields?.includes(FLEXICO_TEMPLATE_KEYS.approvers)
                && flexicoTemplateDataEdited?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.approvers) && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approvers]?.length == 0) {
                missingFields = [...missingFields, FLEXICO_TEMPLATE_KEYS.approvers]
            }
            let missingFields2 = getMissingFields(flexicoTemplateDataEdited, [{ mainKey: FLEXICO_TEMPLATE_KEYS.approvers, subKeys: [FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.alias, FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.type] }])
            missingFields = [...missingFields, ...missingFields2]

        }

        let approvalDecision = true
        if (!validateSoxRequirements(flexicoTemplateDataEdited)) {
            approvalDecision = false
        } else if (flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.approval_required) && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approval_required] && flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.approvers)
            && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approvers] && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approvers].length <= 0) {
            approvalDecision = false
        }
        setEnableEditAction(missingFields.length <= 0 && approvalDecision && ((isNewFlexicoTemplate && canAdd) || (isEditMode && canEdit)))
    }

    const validateSoxRequirements = (flexicoTemplateDataEdited) => {
        if (flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.sox_approved) && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved]) {
            // if(flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.sox_evidence) && !flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_evidence] && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_evidence] == ""){
            //   return false
            // }
            if (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approvers].length < 2) {
                let groupCount = 0
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.approvers].forEach((approver) => {
                    if (approver[FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.type] == APPROVER_TYPES.APPROVER_LDAP) {
                        groupCount = groupCount + 1
                    }
                })
                if (groupCount > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        } else {
            return true
        }
    }

    const addTemplateDetails = async () => {
        setErrorMessage("")
        let missingFields = getMissingFields(flexicoTemplateDataEdited, [FLEXICO_TEMPLATE_KEYS.template_name,FLEXICO_TEMPLATE_KEYS.trigger_type])
        if (missingFields && missingFields.length > 0) {
            setErrorMessage('missing mandatory fields : ' + missingFields.join(","))
        } else {
            setShowLoadingIcon(true)
            let group_id = getGroup()
            if (group_id) {
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.group_id] = group_id
            }

            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.last_updated_by] = userId
            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.created_by] = userId
            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.step_function_name] = FLEXICO_STEP_FUNCTION_CONFIG.find((c) => c.environment === currentStage)?.arn;
            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.status] = FLEXICO_TEMPLATE_STATUS.TEMPLATE_CREATED
            if (!flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.parameters)) {
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.parameters] = []
            }
            // let jobParameter = {}
            // jobParameter[FLEXICO_TEMPLATE_KEYS.PARAMETER_KEYS.field_type] = 'fixed_inputs'
            // jobParameter[FLEXICO_TEMPLATE_KEYS.PARAMETER_KEYS.field_values] = [FLEXICO_GLUE_JOB_CONFIG.find((c) => c.environment === currentStage)?.name]
            // jobParameter[FLEXICO_TEMPLATE_KEYS.PARAMETER_KEYS.label] = 'flexico_internal_job_name'
            // flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.parameters].push(jobParameter)

            await configureGenericAppSync()
            createAuditLog(`FLEXICO`, `ADD_REQ#${getCurrentTime()}`, "Adding a template", JSON.stringify({}), JSON.stringify(flexicoTemplateDataEdited), "ADD REQ", userId, function onSuccess(result) {
                createFlexicoTemplate(flexicoTemplateDataEdited, async function onSuccess(response) {
                    setFlexicoTemplateData(flexicoTemplateDataEdited)
                    setIsNewFlexicoTemplate(false)
                    setIsEditMode(false)
                    setFlexicoTemplateData({...flexicoTemplateData, ...JSON.parse(JSON.stringify(response.data.createFlexicoTemplate))})
                    flexicoTemplateDataRef.current = response.data.createFlexicoTemplate
                    if (tancEnabled) {
                        //enable TANC
                        await enableTANCSync(response.data.createFlexicoTemplate.flex_id, 'FLEXICO', null, 'S3', flexicoTempId)
                    } 
                    setShouldSubmitRipple(true)
                }, function onFailure(error) {
                    setErrorMessage(error?.errors[0]?.message)
                    setShowLoadingIcon(false)
                })
            }, function onFailure(error) {
                setErrorMessage(`Could not log audit. Adding the template was not attempted ${error?.errors[0]?.message}`)
            })

        }
    }

    const updateTemplateDetails = () => {
        setErrorMessage("")
        let missingFields = getMissingFields(flexicoTemplateDataEdited, [FLEXICO_TEMPLATE_KEYS.flex_id, FLEXICO_TEMPLATE_KEYS.template_name, FLEXICO_TEMPLATE_KEYS.step_function_name])
        if (missingFields && missingFields.length > 0) {
            setErrorMessage('missing mandatory fields : ' + missingFields.join(","))
        } else {
            setShowLoadingIcon(true)
            let group_id = getGroup()
            if (group_id) {
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.group_id] = group_id
            }
            let next_step = getParam('next_step')
            if (next_step) {
                flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.next_step] = next_step
            }
            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.last_updated_by] = userId
            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.status] = FLEXICO_TEMPLATE_STATUS.TEMPLATE_UPDATED

            if (updateComments) {
                setErrorMessage("")

                const dataToSend = {
                    ...flexicoTemplateDataEdited,
                    parameters: flexicoTemplateDataEdited.parameters?.map((param) => ({
                        ...param,
                        display_index: param.display_index !== undefined && param.display_index !== null ? String(param.display_index) : param.display_index
                    })) || []
                }

                // add an audit log
                createAuditLog(`FLEXICO#${fid}`, `${getCurrentTime()}`, updateComments, JSON.stringify(flexicoTemplateData), JSON.stringify(dataToSend), "UPDATE REQ", userId,
                    function onSuccess(result) {
                        setUpdateComments("")
                        updateFlexicoTemplate(dataToSend, async function onSuccess(response) {
                            setIsNewFlexicoTemplate(false)
                            setFlexicoTemplateData(flexicoTemplateDataEdited)
                            flexicoTemplateDataRef.current = flexicoTemplateDataEdited
                            if (tancEnabled != tancEnabledExistingStatus) {
                                if (tancEnabled) {
                                    //enable TANC
                                    await enableTANCSync(fid, 'FLEXICO', null, 'S3', flexicoTempId)
                                } else {
                                    //disable TANC
                                    let tancId = tancInfo?.tanc_id
                                    await disableTANCSync(tancId, fid, 'FLEXICO')
                                }
                            }
                            setShouldSubmitRipple(true)

                        }, function onFailure(error) {
                            setIsNewFlexicoTemplate(false)
                            setShowLoadingIcon(false)
                            // cancelEdition()
                            setUpdateNotificationModalError(`Update failed ${error?.errors[0]?.message}`)
                            setUpdateNotificationModal(true)
                        })
                    }, function onFailure(error) {
                        setErrorMessage(`Could not log audit. Updating template was not attempted ${error?.errors[0]?.message}`)
                    })

            } else {
                setShowLoadingIcon(false)
                setErrorMessage("Please provide your comments for the update")
            }

        }
    }

    const cancelEdition = () => {
        setErrorMessage("")
        setIsEditMode(false)
        setFlexicoTemplateDataEdited(flexicoTemplateDataRef.current)
    }

    const editProcess = () => {
        setIsEditMode(true)
        setFlexicoTemplateDataEdited({ ...flexicoTemplateData })
    }

    const delTemplate = async () => {
        if (updateComments) {
            setShowLoadingIcon(true)
            dismissDeleteDialog()
            setModalError("")
            await configureGenericAppSync()
            createAuditLog(`FLEXICO#${fid}`, `${getCurrentTime()}`, updateComments, JSON.stringify(flexicoTemplateData), JSON.stringify({}), "DELETE REQ", userId,
                function onSuccess(result) {
                    setUpdateComments("")
                    deleteFlexicoTemplate(fid, function onSuccess(response) {
                        setShowLoadingIcon(false)
                        setDeleteConfirmationModal(false)
                        history.push(`/App/${id}`)
                    }, function onFailure(error) {
                        setShowLoadingIcon(false)
                        setDeleteConfirmationModal(false)
                        setErrorMessage(`Deletion failed ${error?.errors[0]?.message}`)
                    })
                }, function onFailure(error) {
                    setErrorMessage(`Could not log audit. Deletion was not attempted. ${error?.errors[0]?.message}`)
                })

        } else {
            setModalError("Please provide comments with the reason for deletion")
        }


    }

    const getCurrentTime = () => {
        return Date.now();
    }

    const getDate = (value) => {
        var d = new Date(value)
        return d.toLocaleString()
    }

    const lastUpdatedContent = (<>
        {getValue(FLEXICO_TEMPLATE_KEYS.last_updated_time_stamp) ? <>

            <span className="last_updated"> Last updated : <span className="bold">{getDate(getValue(FLEXICO_TEMPLATE_KEYS.last_updated_time_stamp))}</span></span>
            {getValue(FLEXICO_TEMPLATE_KEYS.last_updated_by) ? <span className="last_updated"> &nbsp; by  <span className="bold">{getValue(FLEXICO_TEMPLATE_KEYS.last_updated_by)}</span></span> : ''}
        </> : ''}
    </>)

    const getStatusIcon = (status) => {
        const positiveStatuses = FLEXICO_POSITIVE_STATUS
        const negativeStatuses = FLEXICO_NEGATIVE_STATUS
        if (positiveStatuses.includes(status)) {
            return <Icon name='status-positive' variant='success' ></Icon>
        } else if (negativeStatuses.includes(status)) {
            return <Icon name='status-negative' variant='error' ></Icon>
        }
        else {
            return <Icon name='status-in-progress' variant='normal' ></Icon>
        }
    }

    const dataClasificationContent = (
        <Box>
            <SpaceBetween direction="horizontal" size="m">
                <Box>Data Generation Platform: <span className={dataGenerationPlatformClass}>{dataGenerationPlatform}</span></Box>
                <Box>Data Share Platform: <span className={dataSharePlatformClass}> {dataSharePlatform} </span></Box>
            </SpaceBetween>
        </Box>
    )

    const notificationConfigurationContent = (
        <SpaceBetween direction="vertical">
            <div className="header_menu">
                <div className="header_left">
                    <Box variant="h1">Notification Preference</Box>
                </div>
            </div>
            <RadioGroup
                onChange={({ detail }) => updateValueCustomAttributes('NOTIFICATION_PREFERENCE', detail.value)}
                value={getCustomAttribute('NOTIFICATION_PREFERENCE', 'FLEXICO')[0] || 'DEFAULT'}
                items={[
                    { value: "DISABLE_ALL", label: "Disable all", description: "No notification updates from the FlexiCo system" },
                    { value: "DISABLE_ALL_WITH_CRITICAL", label: <Box>Disable all & critical emails <span className="errorMessage">(excludes the approval and review emails)</span> </Box>, description: "No notification updates from the FlexiCo system and also review and approvals" },
                    // { value: "FAILURES_ONLY", label: "Failures only", description: "Only failure messages from the FlexiCo system" },
                    { value: "DEFAULT", label: "Send all(default)" }
                ]}
                readOnly={!isEditMode}
            />
        </SpaceBetween>
    )

    const emailConfigurationContent = (
        <SpaceBetween direction="vertical">
            <div>
                <SpaceBetween direction="horizontal" size="s">
                    <Box variant="h4">Notification email Title</Box>
                    <Popover
                        dismissButton={false}
                        position="top"
                        size="small"
                        triggerType="custom"
                        content={PREFERENCE_VARIABLE_INFO}
                    >
                        <Button variant="inline-link">info</Button>  </Popover>
                </SpaceBetween>

                {
                    isEditMode ?

                        <CustomInput field='EMAIL_PREFERENCE_TITLE' placeholder="Email title" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                        : <Box>{getCustomAttribute('EMAIL_PREFERENCE_TITLE', 'FLEXICO')[0]}</Box>
                }
            </div>
            <div>
                <SpaceBetween direction="horizontal" size="s">
                    <Box variant="h4">Approval title</Box>
                    <Popover
                        dismissButton={false}
                        position="top"
                        size="small"
                        triggerType="custom"
                        content={PREFERENCE_VARIABLE_INFO}
                    >
                        <Button variant="inline-link">info</Button>  </Popover>
                </SpaceBetween>
                {
                    isEditMode ?
                        <CustomInput field='APPROVAL_PREFERENCE_TITLE' placeholder="Approval title" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                        : <Box>{getCustomAttribute('APPROVAL_PREFERENCE_TITLE', 'FLEXICO')[0]}</Box>
                }
            </div>
            <div>
                <SpaceBetween direction="horizontal" size="s">
                    <Box variant="h4">Approval Description</Box>
                    <Popover
                        dismissButton={false}
                        position="top"
                        size="small"
                        triggerType="custom"
                        content={PREFERENCE_VARIABLE_INFO}
                    >
                        <Button variant="inline-link">info</Button>  </Popover>
                </SpaceBetween>
                {
                    isEditMode ?
                        <CustomInput field='APPROVAL_PREFERENCE_DESCRIPTION' placeholder="Approval description" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                        : <Box>{getCustomAttribute('APPROVAL_PREFERENCE_DESCRIPTION', 'FLEXICO')[0]}</Box>
                }
            </div>

        </SpaceBetween>
    )

    const rippleSubmitUpdates = (status, data) => {
        setShouldSubmitRipple(false)
        if(status){
            setShowLoadingIcon(false)
            cancelEdition()
            setUpdateNotificationModalError('')
            setUpdateNotificationModal(true)
            setReloadNotifier(!reloadNotifier)
        
            // Update query parameters to reflect the new template without page navigation
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('processId', flexicoTemplateDataRef.current.flex_id);
            searchParams.set('processPage', 'settings');
            history.replace(`${location.pathname}?${searchParams.toString()}`);
        }else{
            setShowLoadingIcon(false)
            setUpdateNotificationModalError(`Please re-submit, updating post processign details failed : ${JSON.stringify(data)}`)
            setUpdateNotificationModal(true)
        }
    }

    const Content = (
        <ContentLayout
                    headerVariant={props.disableAppLayout ? undefined : "high-contrast"}
                    className="content"
                    header={
                        <SpaceBetween size="l">
                            <Header
                                variant="h1"
                            >

                            </Header>

                        </SpaceBetween>
                    }
                >

                    <SpaceBetween size="l" >
                        {
                            alertErrorMessage ? <Alert
                                statusIconAriaLabel="Error"
                                type="error"
                                header={alertErrorMessage?.header}
                            >
                                {alertErrorMessage?.message}
                            </Alert> : ''
                        }

                        <Container
                        >
                            <SpaceBetween direction="vertical">
                                <SpaceBetween direction="horizontal">
                                    <Box variant="h1">FlexiCo Details</Box>
                                    {
                                        !isEditMode && canEdit ?
                                            <Button iconName="edit" variant="icon" onClick={editProcess} /> : <></>
                                    }
                                    {
                                        !isEditMode && canDelete ?
                                            <Button iconName="remove" variant="icon" onClick={() => { setDeleteConfirmationModal(true) }} /> : <></>

                                    }
                                    <Modal
                                        onDismiss={dismissDeleteDialog}
                                        visible={deleteConfirmationModal}
                                        footer={
                                            <Box float="right">
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <Button variant="link" onClick={dismissDeleteDialog} >Cancel</Button>
                                                    <Button disabled={deleteAppName !== flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.template_name]} variant="primary" onClick={delTemplate}  >Confirm</Button>
                                                </SpaceBetween>
                                            </Box>
                                        }
                                        header={
                                            <React.Fragment>
                                                <Box variant="h2">
                                                    Delete confirmation for '{flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.template_name]}'
                                                </Box>
                                            </React.Fragment>
                                        }
                                    >
                                        <SpaceBetween direction="vertical" size="m">
                                            <Box>To confirm deletion, enter the name of the process in the text input field below</Box>
                                            <Box>
                                                <Input placeholder={flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.template_name]} onChange={({ detail }) => setDeleteAppName(detail.value)} value={deleteAppName} />
                                            </Box>
                                            <Box>
                                                <Textarea
                                                    class="description"
                                                    onChange={({ detail }) => setUpdateComments(detail.value)}
                                                    value={updateComments}
                                                    placeholder="Comments"
                                                ></Textarea>
                                            </Box>
                                            <Box>
                                                {modalError && (
                                                    <Box variant="p" color="text-status-error">
                                                        {modalError}
                                                    </Box>
                                                )}
                                            </Box>
                                        </SpaceBetween>
                                    </Modal>

                                    <Modal
                                        onDismiss={dismissUpdateNotifyDialog}
                                        visible={updateNotificationModal}
                                        footer={
                                            <Box float="right">
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <Button variant="primary" onClick={dismissUpdateNotifyDialog}>Okay</Button>
                                                </SpaceBetween>
                                            </Box>
                                        }
                                        header={
                                            <React.Fragment>
                                                <Box variant="h2">
                                                    Update for '{flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.template_name]}'
                                                </Box>
                                            </React.Fragment>
                                        }
                                    >
                                        <SpaceBetween direction="vertical" size="m">
                                            <Box><Icon name="status-positive" variant="success" /> FlexiCo template is updated.</Box>
                                            {
                                                updateNotificationModalError ? <Box variant="p" color="text-status-error">{updateNotificationModalError}</Box> : ''
                                            }
                                        </SpaceBetween>
                                    </Modal>
                                </SpaceBetween>
                                <Box >{lastUpdatedContent}</Box>
                                <br></br>
                            </SpaceBetween>

                            <SpaceBetween size="l">
                                {
                                    !isEditMode ?
                                        <SpaceBetween direction="horizontal" size="m">
                                    {
                                        flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.approval_required)
                                            && flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.approval_required] ?
                                            <Box><span className='orange_badge'>Approval required</span></Box>
                                            : <></>
                                    }
                                    {
                                        flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.sox_approved)
                                            && flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.sox_approved] ?
                                            <Box><span className='green_badge'> 2 touch approval  </span></Box>
                                            : <></>
                                    }
                                        </SpaceBetween>
                                        :
                                        <></>
                                }
                                {
                                    !isNewFlexicoTemplate ? <SpaceBetween direction="vertical" size="s">
                                        <SpaceBetween size="s" direction="horizontal">
                                            <Box>Status :</Box>

                                            {(flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.status) && flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.status]) ?
                                                <SpaceBetween direction="horizontal" size="s"> {getStatusIcon(flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.status])}
                                                    <span className="small_grey_text_italics">{flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.status]}</span></SpaceBetween> : 'Unknown'
                                            }


                                        </SpaceBetween>

                                    </SpaceBetween> : ''
                                }


                                {flashBarComments ? <Flashbar items={flashBarComments} /> : <></>}
                                <ColumnLayout columns={2}>
                                    <div>
                                        <Box variant="h4">FlexiCo template name{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                                        {
                                            isEditMode ?
                                                <CustomInput field={FLEXICO_TEMPLATE_KEYS.template_name} placeholder="FlexiCo template name" updateValue={updateValue} getValue={getValue}></CustomInput>
                                                : flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.template_name) ? flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.template_name] : ''
                                        }
                                    </div>
                                    <div>
                                        <Box variant="h4">Label - To display in the application page</Box>
                                        {
                                            isEditMode ?
                                                <CustomInput field={FLEXICO_TEMPLATE_KEYS.label} placeholder="label" updateValue={updateValue} getValue={getValue}></CustomInput>
                                                : flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.label) ? flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.label] : ''
                                        }
                                    </div>
                                    <div>
                                        <Box variant="h4">Description</Box>
                                        {
                                            isEditMode ?
                                                <Textarea
                                                    class="description"
                                                    onChange={({ detail }) => updateValue(FLEXICO_TEMPLATE_KEYS.description, detail.value)}
                                                    value={getValue(FLEXICO_TEMPLATE_KEYS.description)}
                                                    placeholder="Description"
                                                />
                                                : flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.description) ? flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.description] : ''
                                        }
                                    </div>
                                    <div>
                                        <Box variant="h4">Input type{isEditMode && <Box variant="span" color="text-status-error"> *</Box>}</Box>
                                        {
                                            isEditMode ?
                                                <CustomSelect field={FLEXICO_TEMPLATE_KEYS.trigger_type} getValue={getValue} updateValue={updateValue} getOptions={getSelectFieldValues} />
                                                :
                                                flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type) ? flexicoTemplateData?.[FLEXICO_TEMPLATE_KEYS.trigger_type] : '-'
                                        }
                                    </div>
                                    <div>
                                        <Box variant="h4">Trigger message</Box>
                                        {
                                            isEditMode ?
                                                <Textarea
                                                    class="trigger-message"
                                                    onChange={({ detail }) => updateValueCustomAttributes('TRIGGER_MESSAGE', detail.value)}
                                                    value={getValueCustomAttributes('TRIGGER_MESSAGE')}
                                                    placeholder="This is the message that will be shown when the user first triggers the flexico"
                                                />
                                                : getCustomAttribute('TRIGGER_MESSAGE', 'FLEXICO')[0] || ''
                                        }
                                    </div>
                                    <br/>

                                    {/* load file type is not required, since we are allowing all file type uploads */}

                                    {/* {
                                        flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type) &&
                                            (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file with parameters' || flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file only') ? <div>
                                            <Box variant="h4">Load file type</Box>
                                            {
                                                isEditMode ?
                                                    <CustomMultiSelect field={FLEXICO_TEMPLATE_KEYS.file_types} updateValue={updateValue} getValues={getSelectFieldValues} getSelectedOptions={getMultiSelectedOptions} />
                                                    : flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.file_types) ?
                                                        <ul>
                                                            {flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.file_types]?.map((item) => (
                                                                <li key={item} className="list-item-data">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                        : ''
                                            }
                                        </div>
                                            : ''
                                    } */}
                                    
                                    {
                                        flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type) &&
                                            (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file with parameters' ) ? <div>
                                            <Box variant="h4"></Box>
                                            {
                                                isEditMode ?
                                                <CustomCheckbox field={FLEXICO_TEMPLATE_KEYS.upload_mandatory} getValue={getValue} updateValue={updateValue} text="File upload Mandatory" />
                                                :  ''
                                            }
                                        </div>
                                            : ''
                                    }
                                </ColumnLayout>
                            </SpaceBetween>

                            <SpaceBetween size="m">
                                <SpaceBetween>
                                    {
                                        flexicoTemplateDataEdited.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type) &&
                                        // (flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file with parameters' || flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file only')?
                                        <ColumnLayout columns={2} >

                                        {isEditMode ?
                                            <>
                                                <div>
                                                    <Box variant="h4">&nbsp;</Box>
                                                    <SpaceBetween direction="horizontal" size="s">
                                                        <SpaceBetween direction="horizontal" size="s">
                                                            <CustomCheckbox field={FLEXICO_TEMPLATE_KEYS.sox_approved} getValue={getValue} updateValue={updateValue} text="Enable 2 touch approval" />
                                                            <Button variant="inline-link" onClick={() => { setToolsOpen(!toolsOpen) }}>info</Button>
                                                        </SpaceBetween>
                                                        {
                                                            flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved] ?
                                                                <Box>
                                                                    <Textarea
                                                                        class="Notes"
                                                                        onChange={({ detail }) => updateValue(FLEXICO_TEMPLATE_KEYS.sox_evidence, detail.value)}
                                                                        value={getValue(FLEXICO_TEMPLATE_KEYS.sox_evidence)}
                                                                        placeholder="notes"
                                                                    />
                                                                </Box> : ''
                                                        }
                                                    </SpaceBetween>
                                                    <CustomCheckbox field={FLEXICO_TEMPLATE_KEYS.approval_required} getValue={getValue} updateValue={updateValue} text="Approval required" disabled={isApprovalDisabled || (flexicoTemplateDataEdited?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.sox_approved) && flexicoTemplateDataEdited[FLEXICO_TEMPLATE_KEYS.sox_approved] )} />

                                                </div></> : <>
                                            </>}
                                    </ColumnLayout>
                                        // :<></>
                                    }
                                    
                                </SpaceBetween>

                            <SpaceBetween>
                                <ColumnLayout columns={2}>
                                    <SpaceBetween>
                                        {
                                            isEditMode ?
                                                <Box>
                                                    <CustomCheckbox field={FLEXICO_TEMPLATE_KEYS.critical_data} getValue={getValue} updateValue={updateValue} text="Critical data" disabled={!isNewFlexicoTemplate} />
                                                    <Link external href="https://policy.a2z.com/docs/97/publication">Click here to review Amazon policy on Data Classification Standard</Link>

                                                </Box>
                                                : dataClasificationContent
                                        }
                                    </SpaceBetween>
                                    
                                <div>
                                    <Box variant="h4">TANC Configuration</Box>
                                    {
                                        isEditMode ? <SpaceBetween direction="horizontal" size="m">
                                            <Checkbox
                                                onChange={({ detail }) =>
                                                    setTancEnabled(detail.checked)
                                                }
                                                checked={tancEnabled}
                                            >
                                                Enable inline editing on review
                                            </Checkbox>
                                            {
                                                tancEnabled ? <Button variant="normal" onClick={() => setShowTancPermissionModal(true)}>Manage</Button> : <></>
                                            }
                                        </SpaceBetween> : <>
                                            <Checkbox
                                                checked={tancEnabled}
                                                disabled={!isEditMode}
                                            >
                                                Enable inline editing
                                            </Checkbox>
                                        </>
                                    }

                                    {
                                        tancEnabled && <Box>
                                            <div>
                                                <SpaceBetween direction="horizontal" size="s">
                                                    <Box variant="h4">TANC review title</Box>
                                                    <Popover
                                                        dismissButton={false}
                                                        position="top"
                                                        size="small"
                                                        triggerType="custom"
                                                        content={PREFERENCE_VARIABLE_INFO}
                                                    >
                                                        <Button variant="inline-link">info</Button>  </Popover>
                                                </SpaceBetween>
                                                {
                                                    isEditMode ?
                                                        <CustomInput field='TANC_REVIEW_PREFERENCE_TITLE' placeholder="TANC review title" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                                                        : <Box>{getCustomAttribute('TANC_REVIEW_PREFERENCE_TITLE', 'FLEXICO')[0]}</Box>
                                                }
                                            </div>
                                            <div>
                                                <SpaceBetween direction="horizontal" size="s">
                                                    <Box variant="h4">TANC review description</Box>
                                                    <Popover
                                                        dismissButton={false}
                                                        position="top"
                                                        size="small"
                                                        triggerType="custom"
                                                        content={PREFERENCE_VARIABLE_INFO}
                                                    >
                                                        <Button variant="inline-link">info</Button>  </Popover>
                                                </SpaceBetween>
                                                {
                                                    isEditMode ?
                                                        <CustomInput field='TANC_REVIEW_PREFERENCE_DESCRIPTION' placeholder="TANC review description" updateValue={updateValueCustomAttributes} getValue={getValueCustomAttributes}></CustomInput>
                                                        : <Box>{getCustomAttribute('TANC_REVIEW_PREFERENCE_DESCRIPTION', 'FLEXICO')[0]}</Box>
                                                }
                                            </div>
                                        </Box>
                                    }

                                        
                                        <Modal
                                            onDismiss={() => setShowTancPermissionModal(false)}
                                            visible={showTancPermissionModal}
                                            header="Manage permissions"
                                            size="max"
                                        >
                                            {
                                                showTancPermissionModal ? <TANCManager appId={id} userId={userId} isNewParent={isNewFlexicoTemplate} parentInfo={isEditMode ? flexicoTemplateDataEdited : flexicoTemplateData} parentType={'FLEXICO'} tancId={tancInfo?.tanc_id ? tancInfo?.tanc_id : flexicoTempId} ref={tancManagerRef}></TANCManager>
                                                    : <></>
                                            }
                                        </Modal>
                                    </div>
                                    
                                </ColumnLayout>
                            </SpaceBetween>

                                <ParameterDetails
                                    isEditMode={isEditMode}
                                    isNewFlexicoTemplate={isNewFlexicoTemplate}
                                    canEdit={canEdit}
                                    isDynamicInputParametersAvailable={isDynamicInputParametersAvailable}
                                    showRefreshModal={showRefreshModal}
                                    refreshModal={refreshModal}
                                    fid={fid}
                                    id={id}
                                    flexicoTemplateDataEdited={flexicoTemplateDataEdited}
                                    getValue={getValue}
                                    postProcessTeamEmails={postProcessTeamEmails}
                                    mandatoryParameters={mandatoryParameters}
                                    updateValue={updateValue}
                                />

                                <SpaceBetween size="l">
                                    <ColumnLayout columns={2}>
                                        <div>
                                            <SpaceBetween direction="vertical">
                                                <div className="header_menu">
                                                    <div className="header_left">
                                                        <Box variant="h1">Trigger permissions</Box>
                                                    </div>
                                                </div>
                                                {
                                                    isEditMode ?
                                                        <CustomMultiHybridInputAndSelect field={FLEXICO_TEMPLATE_KEYS.uploaders}
                                                            inputKey={FLEXICO_TEMPLATE_KEYS.UPLOADER_KEYS.alias} selectKey={FLEXICO_TEMPLATE_KEYS.UPLOADER_KEYS.type} selectHint="Choose type"
                                                            placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                                            updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true} 
                                                            loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading}/>
                                                        :
                                                        <div>
                                                            {getValue(FLEXICO_TEMPLATE_KEYS.uploaders) ? <Table
                                                                columnDefinitions={[
                                                                    {
                                                                        id: "variable",
                                                                        header: "Type",
                                                                        cell: item => (item[FLEXICO_TEMPLATE_KEYS.UPLOADER_KEYS.type] == UPLOADER_TYPES.UPLOADER ? 'USER' : 'LDAP') || "-",
                                                                        isRowHeader: true
                                                                    },
                                                                    {
                                                                        id: "alt",
                                                                        header: "Alias",
                                                                        cell: item => item[FLEXICO_TEMPLATE_KEYS.UPLOADER_KEYS.alias] || "-",
                                                                        sortingField: "alt"
                                                                    }
                                                                ]}
                                                                items={getValue(FLEXICO_TEMPLATE_KEYS.uploaders)}
                                                                loadingText="Loading uploaders details"
                                                                sortingDisabled
                                                                empty={
                                                                    <Box
                                                                        margin={{ vertical: "xs" }}
                                                                        textAlign="center"
                                                                        color="inherit"
                                                                    >
                                                                        <SpaceBetween size="m">
                                                                            <b>No uploaders yet</b>
                                                                        </SpaceBetween>
                                                                    </Box>
                                                                }
                                                                variant='embedded'
                                                            /> : ''}
                                                        </div>
                                                }

                                            </SpaceBetween>
                                        </div>

                                        {
                                            (flexicoTemplateData?.approval_required || flexicoTemplateDataEdited?.approval_required) ?
                                                <SpaceBetween>
                                                    <br></br>
                                                    <div>
                                                        <SpaceBetween direction="vertical">
                                                            <div className="header_menu">
                                                                <div className="header_left">
                                                                    <Box variant="h1">Approver(s) Details</Box>
                                                                </div>
                                                            </div>
                                                            {
                                                                isEditMode && flexicoTemplateDataEdited?.approval_required ?
                                                                    <CustomMultiHybridInputAndSelect field={FLEXICO_TEMPLATE_KEYS.approvers}
                                                                        inputKey={FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.alias} selectKey={FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.type} selectHint="Choose type"
                                                                        placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                                                        updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                                                        needIndex={true} indexKey={FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.column_index} indexPlaceHolder="Order of approval" defIndex={0}
                                                                        loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading}/>
                                                                    :
                                                                    <div>
                                                                        {getValue(FLEXICO_TEMPLATE_KEYS.approvers) ? <Table
                                                                            columnDefinitions={[
                                                                                {
                                                                                    id: "variable",
                                                                                    header: "Type",
                                                                                    cell: item => (item[FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.type] == APPROVER_TYPES.APPROVER ? 'USER' : 'LDAP') || "-",
                                                                                    isRowHeader: true
                                                                                },
                                                                                {
                                                                                    id: "alt",
                                                                                    header: "Alias",
                                                                                    cell: item => item[FLEXICO_TEMPLATE_KEYS.APPROVER_KEYS.alias] || "-",
                                                                                    sortingField: "alt"
                                                                                }
                                                                            ]}
                                                                            items={getValue(FLEXICO_TEMPLATE_KEYS.approvers)}
                                                                            loadingText="Loading approver details"
                                                                            sortingDisabled
                                                                            empty={
                                                                                <Box
                                                                                    margin={{ vertical: "xs" }}
                                                                                    textAlign="center"
                                                                                    color="inherit"
                                                                                >
                                                                                    <SpaceBetween size="m">
                                                                                        <b>No approvers yet</b>
                                                                                    </SpaceBetween>
                                                                                </Box>
                                                                            }
                                                                            variant='embedded'
                                                                        /> : ''}
                                                                    </div>
                                                            }
                                                        </SpaceBetween>
                                                    </div>

                                                </SpaceBetween> : <></>
                                        }
                                    </ColumnLayout>

                                </SpaceBetween>

                            <SpaceBetween>
                                <ColumnLayout columns={2}>
                                    <Box>{notificationConfigurationContent}</Box>
                                    <Box>{emailConfigurationContent}</Box>
                                </ColumnLayout>
                            </SpaceBetween>

                            {
                                isNewFlexicoTemplate || flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.mapping_id] ? 
                                <RippleComponentManager isEditMode={ isEditMode} isNewMode={isNewFlexicoTemplate} shouldSubmit={shouldSubmitRipple} submissionUpdates={rippleSubmitUpdates} parentInfo={{...flexicoTemplateData}} mappingId={flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.mapping_id]} appId={flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.app_id]} idType={RippleIDTypes.FLEXICO} maxConfigurations={1} reloadNotifier={reloadNotifier}></RippleComponentManager>: <></>
                            }
                            </SpaceBetween>

                        </Container>
                    </SpaceBetween>
                    <SpaceBetween size="m">
                        <Box>
                            {errorMessage && (
                                <Box variant="p" color="text-status-error">
                                    {errorMessage}
                                </Box>
                            )}
                        </Box>
                        {
                            (isNewFlexicoTemplate && canAdd) ?
                                <div className="buttons">
                                    <SpaceBetween direction="horizontal" size="l">
                                        <Button variant="primary" onClick={addTemplateDetails}
                                            >Save</Button>
                                    </SpaceBetween>
                                </div>
                                :
                                ''
                        }
                        {
                            !isNewFlexicoTemplate && isEditMode ?
                                <SpaceBetween direction="vertical" size="l">
                                    <Textarea
                                        class="description"
                                        onChange={({ detail }) => setUpdateComments(detail.value)}
                                        value={updateComments}
                                        placeholder="Comments"
                                    ></Textarea>
                                    <div className="buttons">
                                        <SpaceBetween direction="horizontal" size="l">
                                            <Button variant="primary" onClick={updateTemplateDetails} disabled={!enableEditAction} >Update</Button>

                                            <Button onClick={cancelEdition}>Cancel</Button>
                                        </SpaceBetween>
                                    </div>
                                </SpaceBetween>
                                :
                                ''
                        }
                    </SpaceBetween>

                    <br />
                    {
                        !isNewFlexicoTemplate && !isEditMode ?
                            <SpaceBetween size="l" >
                                <Feedback appId={id} pageId={`flexico_template_${id}_${fid}`} userId={userId} parentId={"null"} level={0} limit={1}></Feedback>
                            </SpaceBetween> : ''
                    }

                    {
                        showLoadingIcon ? <Modal visible={showLoadingIcon}>
                        <Box>
                            <Spinner></Spinner>
                            Loading...
                        </Box>
                    </Modal> :<></>
                    }
                </ContentLayout>
    )

    const helpContent = (
        <HelpPanel header={<Box variant="h2">Glossary</Box>}>
            <Box>
                <SpaceBetween direction="horizontal" size="s">
                    {/* <Box variant="strong">2 touch approval</Box> */}
                    {/* <Box>Check the box if the use case is 'Enable 2 touch approval' for the two touch approval workflow for SOX purposes or for other regulatory purposes (such as statutory disclosure generation or publicly published balances such as TTC).</Box> */}
                    <h4>2 touch approval required if</h4>
                    <ul>
                        <li>a) Ledger Impact = Primary Ledger (US GAAP) OR Secondary Ledger (Local GAAP) OR Both Primary and Secondary Ledger (US GAAP/Local GAAP/IFRS) AND</li>
                        <li>b) Financial Impact &gt; $500MM</li>
                    </ul>
                    <h4>2 touch approval NOT required if</h4>
                    <ul>
                        <li>a) Ledger Impact = Other regulations OR Operational AND</li>
                        <li>b) Financial Impact &lt; $500MM</li>
                    </ul>
                </SpaceBetween>
            </Box>
        </HelpPanel>
    );


    return (
        <AppLayout
            disableContentPaddings={true}
            content={Content}
            navigation={ <SideNav activeHref={`/App/${id}/flexico/${fid}`} id={id} fid={fid} process={flexicoTemplateData} back={backUrl} /> }
            navigationHide={props.disableAppLayout }
            contentType="default"
            navigationOpen={NavOpen}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            tools={helpContent}
            toolsOpen={toolsOpen}
            onToolsChange={() => { setToolsOpen(!toolsOpen) }}
            headerVariant={props.disableAppLayout  ? undefined : "high-contrast"}
        />
    );
};
